import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Accordion } from 'shared/components/Accordion';
import { MatchFormFields } from 'modules/matches/interfaces/forms';
import { useSelector } from 'react-redux';
import { gamesSelectorFactory } from 'modules/games/store/games/selectors';
import { MatchSummary } from 'modules/matches/components/MatchSummary';
import { MATCH_PLAYERS_DEFAULT_SETTINGS } from 'modules/matches/constants';
import { MatchEntity } from 'app/interfaces/entity';

interface MatchSummaryFormProps {
  onAccordionClick: () => void;
  isExpanded: boolean;
}

export const MatchSummaryForm: FC<MatchSummaryFormProps> = ({ onAccordionClick, isExpanded }) => {
  const { watch } = useFormContext<MatchFormFields>();

  const entryFee = watch('entryFee');
  const gameId = watch('gameId');
  const accessibility = watch('accessibility');
  const clockLimit = watch('clockLimit');
  const clockIncrement = watch('clockIncrement');
  const matchSetupSettings = watch('matchSetupSettings');
  const maxPlayersCount =
    watch('playersSettings.maxPlayersCount') ?? MATCH_PLAYERS_DEFAULT_SETTINGS.maxPlayersCount;

  const selectedGame = useSelector(gamesSelectorFactory.useById(gameId));

  return (
    <Accordion title="Match Summary" onChange={onAccordionClick} expanded={isExpanded}>
      <MatchSummary
        game={selectedGame}
        accessibility={accessibility}
        entryFee={entryFee}
        clockLimit={clockLimit}
        clockIncrement={clockIncrement}
        matchSetupSettings={matchSetupSettings as unknown as MatchEntity['matchSetupSettings']}
        maxPlayersCount={maxPlayersCount}
      />
    </Accordion>
  );
};
